<app-auth-header></app-auth-header>
<section class="section-gap noFoundPage">
  <div class="container">
    <section class="loaderContentImg">
      <img src="./../../../assets/belairtrip_assets/svg_icon/noSeat.svg" alt="Belairtrip 404" class="img-fluid w-25">
      <div class="row">
        <div class="col-12">
          <h4>Page Not Found</h4>
          <p>We can't seem to find the page you are looking for.</p>
          <button mat-button class="searchAgain" (click)="searchAgain()">Search Again</button>
        </div>
      </div>
    </section>
  </div>
</section>
<app-auth-footer></app-auth-footer>
